import React from "react";
import moment from "moment";

export const ExpirationInfo = ({ ad }) => {

  const today = moment().startOf("day");

  const expireDate = moment(ad.expirationDate).startOf("day");
  const remainingDays = expireDate.diff(today, "days");
  const remainingYears = expireDate.diff(today, "year");

  let value: string;

  if (remainingYears > 5) {
    // Dont show anything if ad expiration date is bigger than 5 years
    return null
  }

  if (remainingDays == 0) {
    value = `${"danas"}`;
  }
  else {
    value = `${remainingDays} ${remainingDays === 1
      ? "dan"
      : "dana"
      }`;
  }

  return <div>Do isteka <strong>{value}</strong></div>
}


// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/AdCard/ExpirationInfo.tsx